import {
  Activity,
  CalendarClock,
  CalendarX,
  CheckCircle2,
  FileClock,
  FileText,
  Inbox,
  Info,
  Store,
  Tags,
  XCircle,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils/cn';
import { NotificationType } from '../types/notification.types';

/**
 * El ícono de cada aviso en la campana, con el color de su módulo (Compite magenta,
 * Cotiza violeta) o de lo que dice (aprobado verde, rechazado rojo). Así la lista
 * se lee de un vistazo: qué es de la competencia, qué espera una decisión, qué ya
 * salió a la tienda.
 */
const ICONOS: Record<NotificationType, { icono: LucideIcon; fondo: string }> = {
  [NotificationType.COMPETITOR_PRICE_CHANGE]: { icono: Activity, fondo: 'bg-prixia-sky' },
  [NotificationType.PRICES_TO_DECIDE]: { icono: Tags, fondo: 'bg-prixia-sky' },
  [NotificationType.PRICES_PUBLISHED]: { icono: Store, fondo: 'bg-ok' },
  [NotificationType.STRATEGY_EXPIRED]: { icono: CalendarX, fondo: 'bg-prixia-sky' },
  [NotificationType.QUOTE_SUBMITTED_FOR_APPROVAL]: { icono: FileClock, fondo: 'bg-prixia-blue' },
  [NotificationType.QUOTE_APPROVED]: { icono: CheckCircle2, fondo: 'bg-ok' },
  [NotificationType.QUOTE_REJECTED]: { icono: XCircle, fondo: 'bg-destructive' },
  [NotificationType.QUOTE_ADJUSTMENT_REQUESTED]: { icono: FileText, fondo: 'bg-prixia-gold' },
  [NotificationType.QUOTE_EXPIRED]: { icono: CalendarX, fondo: 'bg-prixia-blue' },
  [NotificationType.QUOTE_CANCELLED]: { icono: XCircle, fondo: 'bg-muted-foreground' },
  [NotificationType.QUOTE_FOR_INFORMATION]: { icono: Info, fondo: 'bg-prixia-blue' },
  [NotificationType.QUOTE_BUDGET_EXCEEDED]: { icono: Info, fondo: 'bg-prixia-gold' },
  // Demo que vence (2-nov): avisos a la plataforma.
  [NotificationType.DEMO_POR_VENCER]: { icono: CalendarClock, fondo: 'bg-prixia-gold' },
  [NotificationType.DEMO_VENCIDA]: { icono: CalendarX, fondo: 'bg-destructive' },
  // Landing nueva (vault 346): llegó una solicitud de Mini Prixia.
  [NotificationType.SOLICITUD_MINI_PRIXIA]: { icono: Inbox, fondo: 'bg-prixia-gold' },
};

export function IconoDeAviso({ tipo, className }: { tipo: NotificationType; className?: string }) {
  const { icono: Icono, fondo } = ICONOS[tipo] ?? { icono: Info, fondo: 'bg-muted-foreground' };
  return (
    <span
      aria-hidden="true"
      className={cn(
        'flex size-7 shrink-0 items-center justify-center rounded-lg text-white', // pulido: permitido — ícono blanco sobre el color del módulo
        fondo,
        className
      )}
    >
      <Icono className="size-4" />
    </span>
  );
}
